import React, { useCallback, useEffect, useMemo, useState } from "react";
import { View } from "react-native";
import { Error } from "../../atoms/error/Error";
import { Field } from "../../atoms/field/Field";
import { Icon } from "../../atoms/icon/Icon";
import { Text } from "../../atoms/text/Text";
import { style as inputFiledStyle } from "./InputField.style";
const InputField = ({ label, value, error, hint, style: customStyle, input, icon }) => {
    const style = useMemo(() => inputFiledStyle(), []);
    const [isFocused, setIsFocused] = useState(false);
    const [isFilled, setIsFilled] = useState(Boolean(value));
    useEffect(() => setIsFilled(Boolean(value)), [value]);
    const handleOnBlur = useCallback(() => setIsFocused(false), []);
    const handleOnFocus = useCallback(() => setIsFocused(true), []);
    const color = error ? style.colorTextError : isFocused ? style.colorText : style.colorTextMedium;
    const borderColor = error
        ? style.colorBorderInputError
        : isFocused
            ? style.colorBorderInputFocus
            : style.colorBorderInteractive;
    const iconColor = error ? style.colorIconError : isFocused ? style.colorIcon : style.colorIconLight;
    return (React.createElement(View, { style: customStyle?.inputField, testID: "input-field" },
        React.createElement(View, null,
            React.createElement(Field, { isFocused: isFocused || isFilled, label: label, style: {
                    field: customStyle?.field,
                    fieldText: [{ color }, customStyle?.fieldText],
                } }),
            input({
                onBlur: handleOnBlur,
                onFocus: handleOnFocus,
                style: {
                    container: [
                        !!icon && { paddingRight: style.inputPaddingRightWithIcon },
                        { borderColor },
                        style.inputContainer,
                        customStyle?.input?.container,
                    ],
                    input: customStyle?.input?.input,
                },
            })),
        !!icon && React.createElement(Icon, { name: icon, style: [style.icon, { color: iconColor }, customStyle?.icon] }),
        !!error && React.createElement(Error, { error: error, level: 3, style: [style.error, customStyle?.error] }),
        !!hint && (React.createElement(Text, { level: 3, style: [style.hint, { color }, customStyle?.hint], variant: "detail" }, hint))));
};
export { InputField };
